import { Component, Input } from '@angular/core';
import { MatSidenav } from '@angular/material';

@Component({
  selector: 'app-left-sidenav-controls',
  templateUrl: './left-sidenav-controls.component.html',
  styleUrls: ['./left-sidenav-controls.component.scss']
})
export class LeftSidenavControlsComponent {
  @Input() sidenav: MatSidenav;
  @Input() title: string;
  @Input() icon: string;

  openSideNav() {
    this.sidenav.open();
  }

  closeSideNav() {
    this.sidenav.close();
  }

  visibleWhen(isOpened: boolean): string {
    return isOpened ? 'visible' : 'hidden';
  }
}
